<div class="card-tab-toolbar" *ngIf="hasCard">
    <button *ngIf="!disableActions" mat-button class="new-card-btn" (click)="createNewDebitCard()" [disabled]="(isLoading$ | async)" terraCheckPermissions
            [minimumPermissionLevel]="PermissionLevel.Editor" [minimumFinancialPermissionLevel]="FinancialPermissionLevel.AuthorizedSignatory"
            [noPermissionAction]="NoPermissionAction.PopupOnClick">
        <!-- <terra-loader *ngIf="isLoading$ | async"></terra-loader> -->
        <mat-icon class="material-icons">add</mat-icon>
        NEW CARD
    </button>
</div>
<div class="no-cards" *ngIf="!hasCard">
    <a *ngIf="!disableActions" [ngClass]="{'add-debit-card-wrapper':true, 'isLpSide': isLpSide}" (click)="createNewDebitCard()" terraCheckPermissions
       [minimumPermissionLevel]="PermissionLevel.Editor" [minimumFinancialPermissionLevel]="FinancialPermissionLevel.AuthorizedSignatory"
       [noPermissionAction]="NoPermissionAction.PopupOnClick">
        <img src="/assets/images/general/add_glymph.svg"/>
        <span>ADD NEW CARD</span>
    </a>
    <!-- <terra-loader *ngIf="isLoading$ | async"></terra-loader> -->
</div>
